module.exports = __webpack_public_path__ + "static/img/advance_log.5a1af6bf.png";